export default __webpack_public_path__ + "static/media/crab-token.589300ac.svg";